"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializationProfile = exports.Pattern = void 0;
var Pattern;
(function (Pattern) {
    Pattern[Pattern["PubSub"] = 0] = "PubSub";
    Pattern[Pattern["RequestReply"] = 1] = "RequestReply";
})(Pattern = exports.Pattern || (exports.Pattern = {}));
var SerializationProfile;
(function (SerializationProfile) {
    // Order and numbers of the values should be preserved as this enum gets serialized and a change in order
    // can cause n/n-1 issues during deployment.
    SerializationProfile[SerializationProfile["JSONB"] = 0] = "JSONB";
    SerializationProfile[SerializationProfile["JSON"] = 1] = "JSON";
    SerializationProfile[SerializationProfile["JSOND"] = 2] = "JSOND";
    SerializationProfile[SerializationProfile["Disabled"] = 3] = "Disabled";
    SerializationProfile[SerializationProfile["COMPRESSEDJSON"] = 4] = "COMPRESSEDJSON";
})(SerializationProfile = exports.SerializationProfile || (exports.SerializationProfile = {}));
//# sourceMappingURL=ipubsub.js.map